import { bviInit } from './modules/bvi/bvi'
import {headerScrolled, checkScrolledPosition, toggleMobileMenu} from "./modules/header/header";
import {openModal, submitForm} from "./modules/modal/modal";
import {
    handleClickLoadMorePosts,
    handleClickNextPage,
    handleClickPaginationButton, handleClickPrevPage,
    renderPagination
} from "./modules/pagination/pagination";


(function ($) {
    $(document).ready(()=> {
        const ajaxUrl = window.ajaxUrl;
        const templateUrl = window.templateUrl;


        // Инифиализация версии для слабовидящих
        bviInit()

        // Функция для проверки позиции скролла при загрузке страницы
        checkScrolledPosition()

        // Функция для отслеживания скролла хедера
        headerScrolled()

        // Функция для переключения мобильного меню
        toggleMobileMenu();

        // Маска для телефона
        $('#phone-main').mask('+7 (000) 000-00-00'); // Маска для телефонного номера

        // Обработка открытия и закрытия модального ок
        openModal()

        // Обработка отправки формы
        submitForm()

        if (typeof totalPosts !== 'undefined') {
            // Обработка нажатия на кнопку "Показать ещё" для постов
            handleClickLoadMorePosts(ajaxUrl)

            // Отрисовка пагинации
            renderPagination(1)

            // Обработка нажатия на кнопки пагинации
            handleClickPaginationButton(ajaxUrl)

            // Обработка нажатия на следующую страницу пагиинации "next"
            handleClickNextPage(ajaxUrl)

            // Обработка нажатия на следующую страницу пагиинации "prev"
            handleClickPrevPage(ajaxUrl)
        } else {
            console.log('totalPosts не определен на этой странице');
        }

        // Инициализация яндекс карты
        function init(){
            const map = new ymaps.Map("map", {
                center: [54.953127, 73.382145],
                zoom: 17
            });

            map.controls.remove('geolocationControl'); // удаляем геолокацию
            map.controls.remove('searchControl'); // удаляем поиск
            map.controls.remove('trafficControl'); // удаляем контроль трафика
            map.controls.remove('typeSelector'); // удаляем тип
            map.controls.remove('fullscreenControl'); // удаляем кнопку перехода в полноэкранный режим
            map.controls.remove('zoomControl'); // удаляем контрол зуммирования
            map.controls.remove('rulerControl'); // удаляем контрол правил
            map.behaviors.disable(['scrollZoom']); // отключаем скролл карты (опционально)

            const customIcon = {
                href: templateUrl + '/assets/images/icons/point-Y.svg',
                size: [48, 48],
                offset: [-25, -40]
            };
            const myPlacemark = new ymaps.Placemark([54.953127, 73.382145], {
                balloonContent: 'ул. Всеволода Иванова, 3'
            }, {
                iconLayout: 'default#image',
                iconImageHref: customIcon.href,
                iconImageSize: customIcon.size,
                iconImageOffset: customIcon.offset
            });

            map.geoObjects.add(myPlacemark);
        }
        if ($('#map').length) {
            ymaps.ready(init);
        }
    })
})(jQuery)
